import script from "./PlanAction.vue?vue&type=script&setup=true&lang=js"
export * from "./PlanAction.vue?vue&type=script&setup=true&lang=js"

import "./PlanAction.vue?vue&type=style&index=0&id=25e30053&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25e30053"]])

export default __exports__